import React from 'react'
import Link from 'gatsby-link'
import V1_Articles from '../global/data/v1'


const Archive = ({ data }) => {

  return (
    <div className="page--articles">

      <h1>These are the Articles I had published before Updating the UI of the website</h1>
      <p>In case you're looking for previous website, It's available at <a href="https://v1.dhruvkumarjha.com" target="_blank">https://v1.dhruvkumarjha.com</a></p>

      <div className="component--posts-list archive">
      { V1_Articles.map( link => (
        <div className="post" key={ link.url }>
          <h2><a href={ link.url } target="_blank">{ link.title }</a></h2>
          <p className="published">{ link.date }</p>
          <p>{ link.excerpt }</p>
        </div>
      )) }
      </div>


    </div>
  );

}


export default Archive




// WEBPACK FOOTER //
// ./src/pages/archive.js